import getCollection from './getCollection'
import getDataById from 'actions/base/getDataById'

const getSlot = async (id) => getDataById(id, getCollection)

export default getSlot
